<template>
  <div>
    <b-tabs pills content-class="mt-3">
      <b-tab :title="$t('Server identifier')" active>
        <b-form-group label-align="right" label="Enterprise id" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="mainDHCPv6['server-id']['enterprise-id']"/>
        </b-form-group>
        <b-form-group label-align="right" label="Hardware type" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="mainDHCPv6['server-id'].htype"/>
        </b-form-group>
        <b-form-group label-align="right" label="Identifier" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="mainDHCPv6['server-id'].identifier"/>
        </b-form-group>
        <b-form-group label-align="right" label="Time" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="mainDHCPv6['server-id'].time"/>
        </b-form-group>
        <b-form-group label-align="right" label="DUID type" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="serverIdentifierType" v-model="mainDHCPv6['server-id'].type"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Persist')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox v-model="mainDHCPv6['server-id'].persist"/>
        </b-form-group>
      </b-tab>
      <b-tab :title="$t('DHCPv6 queue control')">
        <b-form-group label-align="right" :label="$t('Capacity')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="mainDHCPv6['dhcp-queue-control'].capacity"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Queue type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="mainDHCPv6['dhcp-queue-control']['queue-type']" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Enable queue')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox v-model="mainDHCPv6['dhcp-queue-control']['enable-queue']"/>
        </b-form-group>
      </b-tab>
      <b-tab :title="$t('Expired leases processing')">
        <b-form-group label-align="right" label="Flush reclaimed timer wait time" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="mainDHCPv6['expired-leases-processing']['flush-reclaimed-timer-wait-time']"/>
        </b-form-group>
        <b-form-group label-align="right" label="Hold reclaimed time" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="mainDHCPv6['expired-leases-processing']['hold-reclaimed-time']"/>
        </b-form-group>
        <b-form-group label-align="right" label="Max reclaim leases" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="mainDHCPv6['expired-leases-processing']['max-reclaim-leases']"/>
        </b-form-group>
        <b-form-group label-align="right" label="Max reclaim time" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="mainDHCPv6['expired-leases-processing']['max-reclaim-time']"/>
        </b-form-group>
        <b-form-group label-align="right" label="Reclaim timer wait time" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="mainDHCPv6['expired-leases-processing']['reclaim-timer-wait-time']"/>
        </b-form-group>
        <b-form-group label-align="right" label="Unwarned reclaim cycles" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="mainDHCPv6['expired-leases-processing']['unwarned-reclaim-cycles']"/>
        </b-form-group>
      </b-tab>
      <b-tab :title="$t('Interfaces config')">
        <b-form-group>
          <b-button class="mb-1" variant="success" size="sm" style="float: right; width: 100px; margin-right: 5%" @click="addInterfaces">{{ $t('Add') }}</b-button>
          <b-form-checkbox style="float: left" v-model="mainDHCPv6['interfaces-config']['re-detect']">Re detect</b-form-checkbox>
        </b-form-group>
        <b-card>
          <b-row>
            <b-col cols="6">
              <h5>{{ $t('Full name') }}</h5>
            </b-col>
            <b-col cols="4"/>
            <b-col>
              <h5>{{ $t('Delete') }}</h5>
            </b-col>
          </b-row>

          <b-row v-for="item in this.interfaces" v-bind:key="item.num">
            <b-col cols="6">
              <b-form-input type="text" v-model="item.name"/>
            </b-col>
            <b-col cols="4"/>
            <b-col>
              <b-button size="sm" id="transparent" @click="deleteInterfaces(item)">
                <b-img :src='deleteImage'/>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab :title="$t('Option-data tab')">
        <b-form-group>
          <b-button class="mb-1" variant="success" size="sm" style="float: right; width: 100px" @click="swohAddOptionData">{{ $t('Add') }}</b-button>
        </b-form-group>
        <b-table small striped hover :items="editItem['option-data']" :fields="optionDataFields">
          <template v-slot:cell(actions)="row">
            <b-button size="sm" @click.stop="editOptionData(row)" id="transparent">
              <b-img :src='editImage'/>
            </b-button>
            <b-button size="sm" @click.stop="deleteOptionData(row)" id="transparent">
              <b-img :src='deleteImage'/>
            </b-button>
          </template>
        </b-table>
      </b-tab>
    </b-tabs>
    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
      </b-col>
    </b-row>
    <modalOptionData
      :selectSubnet="selectSubnet"
      :editItem="editItem"
      :selectOptionData="selectOptionData"/>
  </div>
</template>

<script>
import modalOptionData from '@/pages/settings/DHCPv6/modalOptionData'

export default {
  components: {
    modalOptionData
  },
  data () {
    return {
      selectSubnet: {
        'isSubnet': false
      },
      editItem: {'option-data': []},
      selectOptionData: {
        'name': '',
        'code': '',
        'space': 'dhcp6',
        'csv-format': false,
        'data': ''
      },
      optionDataFields: [
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'code', label: this.$i18n.t('Code'), sortable: true},
        {key: 'space', label: this.$i18n.t('Space'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      serverIdentifierType: [
        {value: 'LL', text: 'LL'},
        {value: 'LLT', text: 'LLT'},
        {value: 'EN', text: 'EN'}
      ],
      interfaces: [],
      numInterfaces: 0,
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png')
    }
  },
  methods: {
    async save () {
      let copy = JSON.parse(JSON.stringify(this.mainDHCPv6))
      let DHCPv6 = {
        'is_test_only': true,
        'loop_count_timeout': 35,
        'config': {'Dhcp6': {}}
      }
      let interfaces = []
      for (let el of this.interfaces) {
        interfaces.push(el.name)
      }
      for (let el of this.editItem['option-data']) {
        delete el.isEdit
        delete el.numOptionData
      }
      copy['option-data'] = this.editItem['option-data']
      copy['server-id']['enterprise-id'] = Number(copy['server-id']['enterprise-id'])
      copy['server-id'].htype = Number(copy['server-id'].htype)
      copy['server-id'].time = Number(copy['server-id'].time)
      copy['dhcp-queue-control'].capacity = Number(copy['dhcp-queue-control'].capacity)
      copy['expired-leases-processing']['flush-reclaimed-timer-wait-time'] = Number(copy['expired-leases-processing']['flush-reclaimed-timer-wait-time'])
      copy['expired-leases-processing']['hold-reclaimed-time'] = Number(copy['expired-leases-processing']['hold-reclaimed-time'])
      copy['expired-leases-processing']['max-reclaim-leases'] = Number(copy['expired-leases-processing']['max-reclaim-leases'])
      copy['expired-leases-processing']['max-reclaim-time'] = Number(copy['expired-leases-processing']['max-reclaim-time'])
      copy['expired-leases-processing']['reclaim-timer-wait-time'] = Number(copy['expired-leases-processing']['reclaim-timer-wait-time'])
      copy['expired-leases-processing']['unwarned-reclaim-cycles'] = Number(copy['expired-leases-processing']['unwarned-reclaim-cycles'])
      copy['interfaces-config'].interfaces = interfaces
      DHCPv6.config.Dhcp6 = copy
      await this.$store.dispatch('Settings/SAVE_DHCPV6', DHCPv6).then(response => {
        if (response.data.result === 0) {
          DHCPv6.is_test_only = false
          let response = this.$store.dispatch('Settings/SAVE_DHCPV6', DHCPv6)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              this.$store.dispatch('Settings/SAVE_CONFIG_DHCPV6')
              setTimeout(this.$store.dispatch, 500, 'Settings/GET_DHCPV6')
              this.$root.$emit('makeToasts')
            }
          })
        } else {
          this.$root.$emit('makeToasts', 'danger', response.data.text, 'Error')
        }
      })
    },
    load () {
      for (let el of this.mainDHCPv6['interfaces-config'].interfaces) {
        let newEl = {
          num: 0,
          name: ''
        }
        newEl.num = ++this.numInterfaces
        newEl.name = el
        this.interfaces.push(newEl)
      }
      let numOptionData = 0
      for (let el of JSON.parse(JSON.stringify(this.mainDHCPv6['option-data']))) {
        el.numOptionData = ++numOptionData
      }
    },
    addInterfaces () {
      let newEl = {
        num: 0,
        name: ''
      }
      newEl.num = ++this.numInterfaces
      this.interfaces.push(newEl)
    },
    deleteInterfaces (row) {
      this.interfaces = this.interfaces.filter((value) => {
        return value.num !== row.num
      })
    },
    swohAddOptionData () {
      this.selectOptionData = {
        'numOptionData': 0,
        'isEdit': false,
        'name': '',
        'code': '',
        'space': 'dhcp6',
        'csv-format': false,
        'data': ''
      }
      this.$root.$emit('bv::show::modal', 'modalOptionData', '#btnShow')
    },
    editOptionData (row) {
      this.selectOptionData = JSON.parse(JSON.stringify(row.item))
      this.selectOptionData.isEdit = true
      this.$root.$emit('bv::show::modal', 'modalOptionData', '#btnShow')
    },
    deleteOptionData (row) {
      this.editItem['option-data'] = this.editItem['option-data'].filter((value) => {
        return value !== row.item
      })
    }
  },
  computed: {
    mainDHCPv6 () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      let mainDHCPv6 = copy.arguments.Dhcp6
      if (!mainDHCPv6['dhcp-queue-control']) {
        mainDHCPv6['dhcp-queue-control'] = {
          capacity: 0,
          'queue-type': '',
          'enable-queue': false
        }
      }
      return mainDHCPv6
    }
  },
  mounted () {
    this.load()
    this.$store.dispatch('Settings/GET_DHCPV6')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/DHCPv6/mainDHCPv6/main.vue